module.exports = __webpack_public_path__ + "img/settings.203298da.svg";